import { SelectOption } from '@pluxee-design-system/core';
import { PayoutChannel, PayoutFrequency } from 'generated/models';
import { LocationsFormValues } from '../types';

export const getSelectedPayout = (
  payoutList?: PayoutFrequency[] | null,
  selectedPayoutId?: string,
) =>
  payoutList?.reduce<PayoutChannel | undefined>(
    (prev, payout) =>
      prev || payout.channelList.find((item) => item.payoutUid === selectedPayoutId),
    undefined,
  );

export const preselectTab = (
  tabs: SelectOption[],
  payouts: Record<string, PayoutFrequency>,
  selectedPayoutUid?: string | null,
) =>
  tabs.find((tab) =>
    Boolean(payouts[tab.value].channelList.find((item) => item.payoutUid === selectedPayoutUid)),
  ) || tabs[0];

export const hasLocationsChanged = ({ locations }: LocationsFormValues) =>
  Object.keys(locations).some((key) => locations[key].oldState !== locations[key].newState);

export const getChangedLocations = (locations: LocationsFormValues['locations']) => {
  const toAdd: string[] = [];
  const toRemove: string[] = [];

  Object.keys(locations).forEach((key) => {
    if (locations[key].oldState !== locations[key].newState) {
      if (locations[key].newState) {
        toAdd.push(key);
      } else {
        toRemove.push(key);
      }
    }
  });

  return { toAdd, toRemove };
};
